export enum Platforms {
  DEVTO = "devto",
  HASHNODE = "hashnode",
  MEDIUM = "medium",
}
